import Router from './routes/router'
import MultiProvider from "./context/multiProvider";
import TagManager from 'react-gtm-module';
import { useEffect } from 'react';

export default function App() {

    useEffect(() => {
        const tagManagerArgs = { gtmId: 'GTM-TJSW7LVM' };
        TagManager.initialize(tagManagerArgs);
      }, []);

    return <MultiProvider>
        <Router />
    </MultiProvider>
}